import { createFileRoute } from "@tanstack/react-router"

import { PlaceholderPanel } from "@/components/shared/PlaceholderPanel"

export const Route = createFileRoute("/intelligence/governance")({
  component: () => (
    <PlaceholderPanel
      title="Governance Dashboard"
      description="Board/IC meeting calendar, governance deadline tracker, corporate record status, policy lifecycle, COI register"
    />
  ),
})
